export default class CommentTypes {
  static COMMENT = "comment";

  static NOTE = "note";

  static TASK = "task";

  static QUESTION = "question";

  static ERROR = "error";
}
